import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

interface HelpPlanBadgeProps {
  plans?: string[]
  available?: boolean
  className?: string
}

function formatPlan(plan: string) {
  return plan.charAt(0).toUpperCase() + plan.slice(1)
}

export function HelpPlanBadge({
  plans = [],
  available,
  className,
}: HelpPlanBadgeProps) {
  if (plans.length === 0) {
    return (
      <Badge
        variant="outline"
        className={cn(
          'border-emerald-200 bg-emerald-50/60 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300',
          className,
        )}
      >
        All plans
      </Badge>
    )
  }

  return (
    <Badge
      variant="outline"
      className={cn(
        available === false
          ? 'border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-300'
          : 'border-sky-200 bg-sky-50 text-sky-800 dark:border-sky-500/20 dark:bg-sky-500/10 dark:text-sky-300',
        className,
      )}
    >
      {plans.map(formatPlan).join(' / ')}
    </Badge>
  )
}
